module.exports = __webpack_public_path__ + "img/icon_next_grey.d4ef07fa.svg";